module.exports = __webpack_public_path__ + "static/media/04.7f86d227.mp3";